import { Injectable } from '@angular/core';
import { CoreRepository } from '@tcc-mono/shared/data-access';
import { SlaughterList } from '@tcc-mono/vandijk/shared/data-access/models';
import { SlaughterListService } from '@tcc-mono/vandijk/shared/data-access/vandijk-api';

@Injectable({
  providedIn: 'root'
})
export class SlaughterListRepository extends CoreRepository<SlaughterList> {

  public constructor(
    protected readonly _SlaughterListService: SlaughterListService
  ) {
    super(
      { name: 'SlaughterLists' },
      _SlaughterListService
    )
  }
}
